import { IAuditTrailDto } from '@/interfaces/dto/IAuditTrailDto';
import ApiHelper from './apiHelper';

export default class Audit {
    static async getAuditTrail (clientId: string): Promise<ReadonlyArray<IAuditTrailDto>> {
        return (await ApiHelper.get(`PushToLiveAuditHistory/${clientId}`)).data as ReadonlyArray<IAuditTrailDto>;
    }
}
